import { render, staticRenderFns } from "./inviteTable.vue?vue&type=template&id=65f82e09&scoped=true"
import script from "./inviteTable.vue?vue&type=script&lang=js"
export * from "./inviteTable.vue?vue&type=script&lang=js"
import style0 from "./inviteTable.vue?vue&type=style&index=0&id=65f82e09&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f82e09",
  null
  
)

export default component.exports